import { BaseServices, HttpMethod } from '@services/base'

import { BridgeService } from './bridge'

export default (accessToken?: string) => {
  const pathname = process.env.REACT_APP_POST_REFINANCING_BEGIN
  const method = HttpMethod.POST
  const host = process.env.REACT_APP_API_HOST
  const headers: Record<string, string> = {}

  if (BridgeService.isBrowser() && accessToken) {
    headers.Authorization = `Bearer ${accessToken}`
  }

  const response = BaseServices.request({
    headers,
    pathname,
    method,
    host,
    data: {},
  })
  return response
}
